import { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AppliedFilters from './AppliedFilters/AppliedFilters';
import Hits from './Hits/Hits';
import Pagination from './Pagination/Pagination';
import Select from './Sorting/Select';
import Stats from './Stats/Stats';
import Widgets from './Widgets/Widgets';
import Navigation from './Navigation/Navigation';
import { hitStylesheet } from '@web/vitafy-react-components';

const Layout = ({ status, currentLayout, categoryId }) => {
  return (
    <>
      <section data-category-id={categoryId} className={`search-layout page-section ${status === 'loading' ? ' search-layout--loading' : ''} ${currentLayout === 'list' ? hitStylesheet['--list-view'] : ''}`}>
        <aside className="search-layout__header" >
          <Stats />
          <Select />
          <AppliedFilters />
        </aside>
        <Widgets />
        <Hits />
      </section>
      <Pagination />
    </>
  );
};

function mapStateToProps({ status, settings, categoryId }) {
  return { status, currentLayout: settings.layout, categoryId };
};

export default connect(mapStateToProps)(Layout);
